<template>

    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=''"/>

    <div id="related-articles">
        <div  v-if="categoryDetails">
            <div id="main-text-content" class="container-size-fixer">

                <div id="direction">
                    <ul v-if="!inheritance">
                        <li class="parent-gray">خانه</li>
                        <li><img width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt=""></li>
                        <li>{{categoryDetails.name}}</li>
                    </ul>
                    <ul v-else>
                        <li v-for="(parent , index) in inheritance" :key="parent" class="inheritance">
                            <span :class="index == inheritance.length+1 ? '' : 'parent-gray'">
                               {{parent.name}}
                            </span>

                            <img width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt="">

                            <span v-if="inheritance.length == index+1">
                                {{categoryDetails.name}}
                            </span>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="main-container related-articles-content row rtl-direction container-size-fixer" v-if="relatedPosts">
                <NewsView v-for="postInfo in relatedPosts" :postInfo="postInfo" :key="postInfo"/>
            </div>
            <div id="footer-btn">
                <a v-on:click="loadMoreRelatedArticles()"  v-if="moreDataExistence && loadingMoodMoreArticles==false">
                    بارگذاری مقالات بیشتر
                </a>
                <img  v-else-if="loadingMoodMoreArticles" style="height: auto;width: 20%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
            </div>
        </div>
        <div v-if="loadingMood">
            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
    </div>
</template>

<script>
    import NewsView from '../components/NewsView'
    import Alert from "../components/Alert"
    import axios from "axios"

    export default {
        data() {
            return {
                alertContent: null,
                loadingMood: false,
                relatedPosts: null,
                categoryDetails: null,
                slug:this.$route.params.slug,
                moreDataExistence : false,
                loadingMoodMoreArticles:false,
                inheritance:null,
            }
        },
        name: "RelatedArticles",
        components: {
            NewsView,
            Alert
        },
        methods: {
            async loadMoreRelatedArticles() {
                try {
                    this.loadingMoodMoreArticles = true;
                    let response = await axios.get('api/loadMoreCategoryRelatedArticles/' + this.categoryDetails.slug + '/' +this.relatedPosts[this.relatedPosts.length-1].slug);
                    this.loadingMoodMoreArticles = false;
                    if(response.data.results.relatedPosts!=null){
                        this.relatedPosts = this.relatedPosts.concat(response.data.results.relatedPosts);
                        this.moreDataExistence = response.data.results.moreDataExistence;
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getRelatedArticles() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getCategoryRelatedArticles/' + this.slug);
                    this.loadingMood = false;
                    this.relatedPosts = response.data.results.relatedPosts;
                    this.categoryDetails = response.data.results.categoryDetails;
                    this.moreDataExistence = response.data.results.moreDataExistence;
                    this.inheritance = response.data.results.inheritance;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getRelatedArticles();
        },
        watch: { $route(to, from) { if(to !== from){ this.slug = this.$route.params.slug;this.categoryDetails = null; this.getRelatedArticles() } } }
    }
</script>

<style lang="scss" scoped>
    #footer-btn {
        width: 100%;
        font-size: 15px;
        color: rgba(26, 26, 26, 1);
        height: 112px;
        line-height: 112px;
    }

    #related-articles {
        padding: 50px 0;
        width: 100%;
        height: auto;
        background-color: white;
    }

    .related-articles-content {
        padding: 0px !important;;
    }

    #main-text-content {
        margin: auto;
        padding: 10px 20px;
    }


    #direction>ul{
        padding: 0;
        text-align: right;
        list-style-type: none;
    }
    #direction>ul>li{
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction>ul>li:nth-child(3){
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
    }
    .inheritance{
        height: auto;
        width: 100%;
        text-align: right;
        display: flex;
        align-items: center;
        img{
            margin: 0 5px;
        }
        color: black!important;
    }
    .parent-gray{
        color: lightgrey;
    }

    .main-container {
        max-width: 1120px;
        width: 100%;
        background-color: white !important;
        margin: auto;
        padding: 50px 15px;
    }

    #related-articles-title {
        width: 100%;
        text-align: right !important;
        font-size: 30px !important;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        span {
            color: #cc171d !important;
        }
    }

    @media (max-width: 1300px) {
        #related-articles-title {
            font-size: 26px !important;
        }
    }
</style>